module.exports = __webpack_public_path__ + "static/media/Original_250.392febe7.jpg";